export const SET_AUTH_MUTATION = 'setUser';
export const PURGE_AUTH_MUTATION = 'logOut';
export const SET_ERROR_MUTATION = 'setError';
export const SET_ME_MUTATION = 'setMe';
export const SET_DECODE_TOKEN_MUTATION = 'setDecodeToken';

export const ADD_LOGIN_MESSAGE_MUTATION = 'addLoginMessageMutation';
export const REMOVE_LOGIN_MESSAGE_MUTATION = 'removeLoginMessageMutation';
export const CLEAR_LOGIN_MESSAGES_MUTATION = 'clearLoginMessageMutation';
